import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DebitCardDTO } from 'src/app/core/models/card';
import { Status } from 'src/app/shared/app.constants';
import { AppUtils } from '../core/app-utils';
import { MemberDTO } from '../core/models/member';
import { CardService } from '../core/services/card.service';
import { MemberService } from '../core/services/member.service';
import { CardDispatcher } from './card/card.dispatcher';
import { ClaimDispatcher } from './claim/claim.dispatcher';
import { CompanyDispatcher } from './company/company.dispatcher';
import { ContentManagementDispatcher } from './content-management/content-management.dispatcher';
import { MemberDispatcher } from './member/member.dispatcher';
import { ShoppingCartDispatcher } from './shopping-cart/shopping-cart.dispatcher';
import { SubsidyDispatcher } from './subsidy/subsidy.dispatcher';

@Injectable({
  providedIn: 'root',
})
export class AppDispatcher implements OnDestroy {
  memberSubscription: Subscription;
  cardSubscription: Subscription;
  cards: DebitCardDTO[];
  isCardDispatched = false;
  constructor(
    private companyDispatcher: CompanyDispatcher,
    private memberDispatcher: MemberDispatcher,
    private cardDispatcher: CardDispatcher,
    private claimDispatcher: ClaimDispatcher,
    private contentManagementDispatcher: ContentManagementDispatcher,
    private memberService: MemberService,
    private shoppingCartDispatcher: ShoppingCartDispatcher,
    private subsidyDispatcher: SubsidyDispatcher,
    private cardService: CardService
  ) {
    this.initializeStore();
  }
  ngOnDestroy(): void {
    if (this.memberSubscription) {
      this.memberSubscription.unsubscribe();
    }
  }
  initializeStore(): void {
    this.contentManagementDispatcher.dispatchContent();
    this.cardDispatcher.dispatchCards(Number(AppUtils.memberId));
    this.claimDispatcher.dispatchClaims(Number(AppUtils.memberId));
    this.memberDispatcher.dispatchMember(Number(AppUtils.memberId));
    this.memberDispatcher.selectStore();
    this.memberSubscription = this.memberService.member$?.subscribe((response: MemberDTO) => {
      if (response) {
        this.companyDispatcher.dispatchCompany(response.idCompany);
        this.subsidyDispatcher.dispatchSubsidy(response.idMember);
      }
    });
    this.shoppingCartDispatcher.dispatchTempShoppingCartDetails(Number(AppUtils.memberId));
    this.shoppingCartDispatcher.dispatchShoppingCartDetails(Number(AppUtils.memberId));
    this.companyDispatcher.selectStore();
    this.contentManagementDispatcher.selectStore();
    this.cardDispatcher.selectStore();
    this.cardSubscription = this.cardService.cards$?.subscribe((res: DebitCardDTO[]) => {
      this.cards = res?.filter(a => a.statusDescription === Status.Active);

      if (!this.isCardDispatched && this.cards && this.cards.length > 0) {
        // sync api call for the balance.
        this.cardService.getSyncCardBalance(this.cards[0].idCard, false, true).subscribe(resSyncBal => {
          if (resSyncBal) {
            this.cardDispatcher.dispatchCards(Number(AppUtils.memberId));
            this.isCardDispatched = true;
          }
        });
        // sync api call for the transactions.
        if (this.cards && this.cards.length > 0) {
          this.cardService.getSyncCardBalance(this.cards[0].idCard, true, false).subscribe(resSyncTransaction => {
            if (resSyncTransaction) {
              this.cardService.cardSyncTransaction$.next(true);
            }
          });
        }
      }
    });
    this.claimDispatcher.selectStore();
    this.shoppingCartDispatcher.selectStore();
    this.subsidyDispatcher.selectStore();
  }
}
